'use client';

import { useContext } from 'react';
import AppContextSidebarContext from './app-context-sidebar-context';

export default function useAppContextSidebar() {
  const context = useContext(AppContextSidebarContext);
  if (!context) {
    throw new Error('useAppSidebar must be used within a AppContextSidebarProvider');
  }
  return context;
}
